export default {
  MAX_LEVEL: 10,
}
